import Vue from 'vue';
import VueRouter from 'vue-router';
import { getURLSearchParams } from '@/utils/utils';
Vue.use(VueRouter);

const routes = [
  {
    path: '/visitorAppointment/index',
    name: 'visitorAppointmentIndex',
    component: () => import('@/sub-app/visitorAppointment/pages/index.vue'),
    meta: {
      title: '访客管理',
      keepAlive: true,
    },
  },
  {
    path: '/visitorAppointment/visitorList',
    name: 'visitorAppointmentVisitorList',
    component: () => import('@/sub-app/visitorAppointment/pages/visitorList.vue'),
    meta: {
      title: '访客管理',
      keepAlive: false,
    },
  }
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // 设置webview标题
  let title = to.meta?.title || '';
  const urlParams = getURLSearchParams();
  if (urlParams && urlParams.title) {
    title = decodeURIComponent(urlParams.title);
  }
  document.title = title;
  next();
});

export default router;
